import IProvider from 'models/Providers/IProvider';
import { client, consoleLogInDev } from 'shared';
import { IGroupMember, IGroup, IHiredProvider } from '../models';

export function refreshMembers(groupId: string | number, callback: (members: IGroupMember[]) => void) {
    client(`api/group-relation/${groupId}`)
        .then((res) => callback(res.group_members ?? []))
        .catch(consoleLogInDev);
}

export function refreshGroup(groupId: string | number, callback: (group: IGroup) => void) {
    client(`api/group/${groupId}`).then(callback).catch(consoleLogInDev);
}

export function getMyGroups(setter: React.Dispatch<React.SetStateAction<IGroup[]>>) {
    client('api/group/?member_only=True').then(setter).catch(consoleLogInDev);
}

export function getAllGroups(setter: React.Dispatch<React.SetStateAction<IGroup[]>>) {
    client('api/group/').then(setter).catch(consoleLogInDev);
}

export function getHiredProviders(groupId: string | number, callback: (providers: IHiredProvider[]) => void) {
    client(`api/group-hires/?group_id=${groupId}`).then(callback).catch(consoleLogInDev);
}
